module.exports = __webpack_public_path__ + "static/media/bd-pyxis-supply-knowledge-portal-overview-for-himss-approved.84073280.pdf";